import {ActivatedRouteSnapshot, BaseRouteReuseStrategy} from "@angular/router";

/**
 * Every game-scoped page sits under the one `:gameId` parent route, so moving between games is a
 * params-only change that Angular's default strategy would serve from the existing component instance.
 */
export class GameScopedRouteReuseStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(futureP: ActivatedRouteSnapshot, currP: ActivatedRouteSnapshot): boolean {
    // `params` holds only that level's params, so levels below `:gameId` compare undefined to undefined and
    // reuse. Refusing at the parent is enough - its whole subtree is rebuilt with it.
    return super.shouldReuseRoute(futureP, currP) && futureP.params['gameId'] === currP.params['gameId'];
  }
}
